import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MarketingSource } from '@common/models';
import { UtilityService } from '@common/services';
import { copyrightString } from 'data/global-strings.data';

@Component({
    selector: 'sbf-overland-expo-west-2023',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './overland-expo-west-2023.component.html',
    styleUrls: ['overland-expo-west-2023.component.scss'],
})
export class OverlandExpoWest2023Component implements OnInit {
    copyrightString = copyrightString;
    constructor(
        private route: ActivatedRoute,
        private utilityService: UtilityService,
        private router: Router
    ) {}

    ngOnInit() {
        const activePath = this.route.snapshot.routeConfig?.path;
        if (!activePath) {
            return;
        }

        let manualMarketingSource: null | MarketingSource = null;

        switch (activePath) {
            case 'expo-west-2023':
                manualMarketingSource = MarketingSource.overlandExpo;
                break;
            case 'expo-west-2023-qr':
                manualMarketingSource = MarketingSource.overlandExpoQR;
                break;
            case 'fb-waitlist':
                manualMarketingSource = MarketingSource.facebook;
                break;
        }
        if (manualMarketingSource) {
            this.utilityService.localStorage.setItem('marketing_source', manualMarketingSource);
        }
        this.router.navigate(['/']);
    }
}
